import axios from "axios";
import { getAccessToken } from "Helpers/session";
import { omitBy, isNil } from "lodash";
import normalizer from "Utils/normalizer";
import { createSessionService } from "./session.service";

const url = `${process.env.API_URL}/${process.env.API_VER}`;
const reportDownloadMicroserviceURL = `${process.env.REPORT_DOWNLOAD_MICROSERVICE_URL}/${process.env.API_VER}`;

interface Sorting {
  sortBy: string;
  mode: "ASC" | "DESC";
}

interface Pagination {
  offset: number;
  limit: number;
}

interface Filter {
  fromDate?: string;
  toDate?: string;
  orgID?: Array<any>;
  orgType?: string;
  deliveryType?: string;
}

export const SERVICE_URL = {
  REPORT: {
    LIST_ORDER: `${reportDownloadMicroserviceURL}/report/order/list`,
    SSE_LIST_ORDER: `${reportDownloadMicroserviceURL}/report/sse/order/list`,
  },
  SSE: {
    SUBSCRIBE: `${reportDownloadMicroserviceURL}/sse/subscription/fetch`,
  },
};

export const getReportOptions = async (orgID: string) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/org/report/options/fetch`,
      data: { orgID },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return normalizer.response.report_option(response.data);
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);
    return { error: { message: err.message } };
  }
};

export const getReportLists = async (
  filters: Filter,
  pagination?: Pagination | null,
  sorting?: Sorting,
) => {
  const accessToken = getAccessToken();

  try {
    const response: any = await axios({
      method: "POST",
      url: `${url}/report/order/list`,
      data: omitBy({ filters: filters, pagination, sorting }, isNil),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return !response.error ? response.data : response;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);
    return { error: { message: err.message } };
  }
};

export const triggerSseReport = async (filters: Filter, sorting?: Sorting) => {
  const accessToken = await createSessionService();

  try {
    const response: any = await axios({
      method: "POST",
      url: SERVICE_URL.REPORT.SSE_LIST_ORDER,
      data: omitBy({ filter: filters, sorting }, isNil),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);
    return { error: { message: err.message } };
  }
};
